<template>
  <div class="hot-industry-concept-container">
    <div class="row header">
      <div class="row header-left">
        <div class="tab-btn">{{title}}</div>
      </div>
      <div class="header-right">
        <sn-tabs class="sn-tabs" :tabs="dateRangeTabs" @change="onDateRangeTabChange"></sn-tabs>
      </div>
    </div>
    <div class="loading" v-loading="isLoading">
      <div class="content-list" v-if="rerender">
        <sn-ranking
            class="content-item"
            :data="topNewsData"
            :isShowIndex="true"
            :emitData="emitCompanyData"
            :sentiment="sentimentColor"
          >
          </sn-ranking>
        <div class="no-data-container" v-if="!isLoading && !topNewsData.length">
          <no-data></no-data>
        </div>
      </div>
    </div>
    <div class="footer">
      <see-more :path="`/top-news-detail?title=${title}&dateType=${type}`"></see-more>
    </div>  
  </div>
</template>

<script>
import SnTabs from '@/components/common/SnTabs';
import NoData from '@/components/common/NoData';
import questionQuery from '@/rest/questionQuery';
import SnRanking from '@/components/common/SnRanking';
import SeeMore from '@/components/common/SeeMore';

export default {
  data() {
    return {
      sentimentColor: 'neutral',
      selectedOptionTab: '',
      dateRangeTabs: ['今天', '近一周'],
      type: 'day',
      rerender: true,
      isLoading: false,
      topNewsData: []
    };
  },
  props: {
    title: {
      type: String
    }
  },
  methods: {
    emitCompanyData() {},
    onFilterTab(res) {
      this.selectedOptionTab = res;
      this.getIndustryRanking();
    },
    onDateRangeTabChange(res) {
      this.type = res.item === '今天' ? 'day' : 'week';
      this.getIndustryRanking();
    },
    getIndustryRanking() {
      questionQuery.getIndustryRanking(this.selectedOptionTab, 15, this.type).then(res => {
        this.topNewsData = res.map(item => {
          return {
            message: item.name,
            num: item.score
          };
        });    
      });
    }
  },
  components: {
    SnTabs,
    NoData,
    SnRanking,
    SeeMore
  },
  mounted() {
    if (this.title === '热门行业排行') {
      this.selectedOptionTab = 'industry';
    }
    this.getIndustryRanking();
  }
};
</script>

<style lang="scss" scoped>
  .hot-industry-concept-container {
    background-color: #3c3a42;
    .header {
      padding: 11px 16px;
      justify-content: space-between;
      width: 100%;
      border-bottom: 1px solid #4f4e55;
      .header-left {
        margin-top: 3px;
        .tab-btn {
          margin-right: 24px;
          color: #ffffff;
          font-weight: 500;
          font-size: 14px;
          cursor: pointer;
        }
        .active {
          position: relative;
        }
        .active::after {
          content: '';
          position: absolute;
          bottom: -11px;
          left: 33px;
          width: 18px;
          height: 4px;
          background-color: #45a8cc;
        }
      }
    }
    .loading {
      height: 236px;
      overflow: auto;
    }
    .content-list {
      height: 100%;
      padding-top: 6px;
      .content-item {
        /deep/.ranking .body .bar-container {
          padding:10px 16px;
        }
        /deep/.ranking .body .bar-container .bar-header .category {
          color:#ffffff;
        }
      }
      .no-data-container {
        height: 266px;
      }
    } 
  }
</style>

